module.exports = __webpack_public_path__ + "img/venue_M.ef40a110.png";